module.exports = __webpack_public_path__ + "assets/2756875147bf6e7de183f725c308c631.png";